import React, { useState, useEffect, useContext, createContext } from "react";
import queryString from "query-string";
// import * as firebase from "firebase";
import firebase from 'firebase'
import "firebase/auth";
import "firebase/storage";
import 'firebase/firestore';
import { snapshotToObjects } from 'util/firestore';
import analytics from 'util/analytics'
import { history } from "./router";
import PageLoader from "components/PageLoader";
import {getFriendlyPlanId} from './prices'
import {apiRequest} from 'util/api/util'
import Cohere from 'cohere-js'
import { sendNewError } from "./slackbot";
// const CONNECT_ACCOUNTS_COLLECTION = process.env.REACT_APP_CONNECT_ACCOUNTS_COLLECTION
const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  appID: process.env.REACT_APP_APP_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  databaseURL: "https://sutra-prod.firebaseio.com"
}

if (!firebase.apps.length) {
  // Replace with your own Firebase credentials
  firebase.initializeApp(config);
  // firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
}

const authContext = createContext();

export function validateEmail(email) {
  if (email.endsWith('.con')) {
      return false
  }
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... update when it changes.
export const useAuth = () => {
  return useContext(authContext);
};

// export default firebase;
export {firebase, config};
const db = firebase.firestore();
export { db };
// Provider hook that creates auth object and handles state
function useProvideAuth() {

  const setUser = (user, userData) => {

    setAuthUser(user)
    if (!user) {
      return
    }
    if (userData) {
      return setUserData(userData)
    }

    return db.collection("users").where("authID", "==", user.uid)
      .get()
      .then(async snapshot => {
          const users = snapshotToObjects(snapshot)
          if (users.length === 1) {
              const platformUser = users[0];
              // return user
              return setUserData(platformUser)
          } else {
            console.log("unable to find user here: ", snapshot)
            console.log("Couldn't find user: ", user)
            await sendNewError(`"unable to find database user: ${user.uid} email: ${user.email}`)
            // await signout()

            throw "Unable to find user"
          }
      })
  }

  const [user, setAuthUser] = useState(null);
  const [userData, setPlatformUserData] = useState(null);
  const setUserData = (data) => {

    setPlatformUserData(data)
    if (!data) {
      return
    }

    Cohere.identify(data.platformID, {
      displayName: (data.firstName ?? "") + " " + (data.lastName ?? ""),
      email: data.email ?? ""
    })
    analytics.identify(data.platformID, {
      firstName: data.firstName ?? "",
      lastName: data.lastName ?? "",
      name: (data.firstName ?? "") + " " + (data.lastName ?? ""),
      email: data.email ?? "",
      isInstructor: data.isInstructor ??  false
    })

    if (!data.isInstructor) {
      return
    }

    return apiRequest(`connect/accountStatus?userId=${data.platformID}`, "GET", null)
      .then(connectAccount => { // JARCH jsut fetch the connect account from the serve... 
        // console.log("GOT CONNECT ACCOUNT: ", connectAccount)
        if (connectAccount) {
          let partner = connectAccount
          // Get values we need for setting up some custom fields below
          const { stripePriceId, stripeSubscriptionStatus } = partner;

          // Add planId field (such as "basic", "premium", etc) based on stripePriceId
          if (stripePriceId) {
            partner.planId = getFriendlyPlanId(stripePriceId);
          } else {
            partner.planId = "starter"
          }

          // Add planIsActive field and set to true if subscription status is "active" or "trialing"
          partner.planIsActive = ["active", "trialing"].includes(
            stripeSubscriptionStatus
          );
          console.log("stripepartner: ", partner)
          // console.log()
          setStripePartner(partner)
        }
      })
    
  }

  const [stripePartner, setStripePartner] = useState(null);

  const convertUser = (email, password) => {
    var credential = firebase.auth.EmailAuthProvider.credential(email, password);
    return user.linkWithCredential(credential)
      .then(response => {
        console.log("Anonymous account successfully upgraded", response.user);
        setUser(response.user);
        return response.user
      })
  };

  const signinWithFacebook = () => {
    var provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('public_profile');
    provider.addScope('email');
    return firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        // console.log("facebook result")
        // console.log(result)
        var token = result.credential.accessToken;
        var user = result.user;
        if (result.additionalUserInfo?.isNewUser) {
          // const createUser = firebase.functions().httpsCallable("createUserFromAuthUser")
          var data = {
            uid: user.uid,
            name: user.displayName,
            email: user.email,
            isAnonymous: false
          }
          return Promise.all([createUser(data), Promise.resolve(result.user)])
        }
        return user
      })
      .then((data) => {
        if (data.length > 1) {
          const [userData, authUser] = data
          setUser(authUser, userData.data)
          return userData
        } else {
          return data
        }
        
      })
  }

  const signin = (email, password) => {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(response => {
        setUser(response.user);
        return response.user;
      });
  };

  const signupWithName = (name, email, password, isInstructor, isStudio, referralUserId=null, referralWidgetName=null) => {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(response => {
        // const createUser = firebase.functions().httpsCallable("createUserFromAuthUser")
        var data = {
          uid: response.user.uid,
          name: name,
          email: response.user.email,
          isAnonymous: false,
          isInstructor: isInstructor,
          isStudio: isStudio,
          referralUserId: referralUserId,
          referralWidgetName: referralWidgetName
        }
        return Promise.all([createUser(data), Promise.resolve(response.user)])
      })
      .then(([userData, authUser]) => {
        setUser(authUser, userData.data)
        analytics.track("CompleteRegistration")
        return userData
      })
  }

  const signout = () => {
    return firebase
      .auth()
      .signOut()
      .then(() => {
        setUser(false);
        setUserData(false);
      });
  };

  const createUser = (data) => {
    const json = data;
    var user = {}

    if (json.uid) {
      user.authID = json.uid;
    }
    
    if (json.email) {
      user.email = json.email;
    }
    user.isAnonymous = json.isAnonymous ?? false
    if (json.name) {
      var splitName = json.name.trim().split(' ')
      if (splitName.length === 1) {
        user.firstName = json.name
        user.lastName = ""
      } else if (splitName.length > 1) {
        user.firstName = splitName.slice(0, -1).join(' ');
        user.lastName = splitName.slice(-1).join(' ')
      }

      user.username = json.name ? json.name : "anonymous"  
    }
    user.platformID = user.authID;
    user.gender = "Prefer not to say"

    if (json.isInstructor) {
      user.region = " "
      user.isInstructor = true
      user.isPartner = true
      user.instructorProfile = {
        aboutMe: {
          story: ""
        },
        instagram: "",
        introUrl: "",
        pageName: user.firstName,
        spotify: ""
      }
      user.widgetName = json.uid
    }
    if (json.isStudio) {
      user.studioMode = true
    }

    if (json.referralWidgetName) {
      user.referralWidgetName = json.referralWidgetName
      user.referralUserId = json.referralUserId
    }

    return db.collection("users")
      .doc(user.authID)
      .set(user)
      .then( () => {
        return user;
      })
  }

  const changeEmail = (newEmail) => {
    return firebase.auth().currentUser.updateEmail(newEmail)
  }

  const sendPasswordResetEmail = email => {
    return firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        return true;
      });
  };

  const confirmPasswordReset = (password, code) => {
    // Get code from query string object
    const resetCode = code || getFromQueryString("oobCode");

    return firebase
      .auth()
      .confirmPasswordReset(resetCode, password)
      .then(() => {
        return true;
      });
  };

  // Subscribe to user on mount
  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        setUser(user);
      } else {
        setUser(false);
        setUserData(false)
      }
    });

    // Subscription unsubscribe function
    return () => unsubscribe();
  }, []);

  return {
    signinWithFacebook,
    user,
    userData,
    stripePartner,
    convertUser,
    signin,
    signupWithName,
    signout,
    sendPasswordResetEmail,
    confirmPasswordReset,
    changeEmail
  };
}

const getFromQueryString = key => {
  return queryString.parse(window.location.search)[key];
};

// A Higher Order Component for requiring authentication
export const requireAuth = (Component) => {
  return (props) => {
    // Get authenticated user
    const auth = useAuth();

    useEffect(() => {
      // Redirect if not signed in
      if (auth.user === false) {
        history.replace("/auth/signin");
      }
    }, [auth]);

    // Show loading indicator
    // We're either loading (user is null) or we're about to redirect (user is false)
    if (!auth.user) {
      return <PageLoader />;
    }

    // Render component now that we have user
    return <Component {...props} />;
  };
};